export default "__VITE_ASSET__9qRhbB_a__"